import Accordion from 'accordion-js';

new Accordion(['.faq-accordion-container']);
